export default {
    auto: 'Automatique',
    manual: 'Manuelle',
    sequential: 'Séquentielle',
};
